<div dropdown>
  <div dropdownToggle class="header__menu top-nav__notify" [class.isAdminMenu]="isAdmin" [class.isNotAdminMenu]="!isAdmin">
    <div _ngcontent-c4="" class="menu-trigger__inner">
      <i _ngcontent-c4="" class="menu-trigger__line"></i>
      <i _ngcontent-c4="" class="menu-trigger__line"></i>
      <i _ngcontent-c4="" class="menu-trigger__line"></i>
    </div>
    <span class="menu__text">
      Menu
    </span>
    <img src="assets/images/nav-arrow-down-menu.svg">
  </div>
  <div *dropdownMenu class="dropdown-menu header-menu-dropdown-menu dropdown-menu-left" role="menu">
      <ul *ngIf="items?.length" id="menu-dropdown" class="navigation">
        <li *ngFor="let parent of items; let index= index" (mouseover)="top(index)">
          <ul *ngIf="!parent.external && parent.items!=''" [class.ul-with-scroll]="haveScroll" class="navigation" [style.top.px]="haveScroll ? parent?.topHeight : null">
            <li>
              <a *ngFor="let child of parent.items" [routerLink]="child.url" routerLinkActive="active">{{child.label}}</a>
            </li>
          </ul>
          <ul *ngIf="parent.external && parent.items!=''" [class.ul-with-scroll]="haveScroll" class="navigation" [style.top.px]="haveScroll ? parent?.topHeight : null">
            <li>
              <a *ngFor="let child of parent.items" [href]="buildHrefUrl( child.url )" target="_blank" routerLinkActive="active">{{child.label}}</a>
            </li>
          </ul>
          <a [attr.id]="'menu' + index" *ngIf="!parent.external" [routerLink]="parent.url" routerLinkActive="active">{{parent.label}}    <img class="right-icon-menu" *ngIf="parent.items?.length>0" src="assets/images/arrow-right-menu-25.svg"></a>
          <a [attr.id]="'menu' + index" *ngIf="parent.external" [href]="buildHrefUrl( parent.url )" target="_blank" routerLinkActive="active">{{parent.label}}    <img class="right-icon-menu" *ngIf="parent.items?.length>0" src="assets/images/arrow-right-menu-25.svg"></a>
        </li>
      </ul>
  </div>
